import { useMutation } from '@apollo/client';
import React, { useEffect, useMemo, useState } from 'react';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useForm } from 'react-hook-form';
import { FORM_PAGES } from '../../../components/Form/types';
import FormText from '../../../components/FormText/FormText';
import { FORM_TEXT_TYPES } from '../../../components/FormText/types';
import { vars } from '../../../reactive';
import { increaseFormPage, setFormPage } from '../../../reactive/actions';
import { AnalyticsEvents, trackEvent } from '../../../utils/analytics';
import { CheckEmailTaken } from '../../../utils/queries';

const FormAccountEmail = () => {
  const [captchaError, setCaptchaError] = useState<string>('');
  const { register, handleSubmit, reset, formState } = useForm();
  const [checkEmailExists, { loading, error, data }] = useMutation(CheckEmailTaken, {
    fetchPolicy: 'no-cache'
  });

  const onSubmit = (data: Record<string, string>) => {
    const account = vars.newAccount();
    const newEmail = data.email.toLowerCase();
    if (!account.captcha) {
      return setCaptchaError('Validation failed, please use a different browser or refresh the page.');
    }
    vars.newAccount({ ...account, email: newEmail });
    checkEmailExists({ variables: { email: newEmail } });
    trackEvent(AnalyticsEvents.EMAIL_INPUT);
  };

  useEffect(() => {
    const account = vars.newAccount();
    if (data) {
      if (data.checkEmailAppUser.exists) {
        vars.newAccount({ ...account, exists: true });
        setFormPage(FORM_PAGES.CREATE_ACCOUNT_CODE);
      } else {
        vars.newAccount({ ...account, exists: false });
        increaseFormPage();
      }
    }
  }, [data]);

  useEffect(() => {
    vars.newAccount({ ...vars.newAccount(), captcha: null });
  }, []);

  const Recaptcha = useMemo<JSX.Element>(
    () => (
      <GoogleReCaptcha
        onVerify={token => {
          if (token) {
            vars.newAccount({ ...vars.newAccount(), captcha: token });
          } else {
            vars.newAccount({ ...vars.newAccount(), captcha: null });
          }
        }}
      />
    ),
    []
  );

  return (
    <FormText
      type={FORM_TEXT_TYPES.EMAIL}
      formOptions={{ register, handleSubmit, reset, formState }}
      onSubmit={onSubmit}
      loading={loading}
      error={error}
      captchaError={captchaError}
      Recaptcha={Recaptcha}
      previousPage={{
        page: vars.isFormFillView() ? FORM_PAGES.FORM_SELECT : FORM_PAGES.PRODUCTS
      }}
    />
  );
};
export default FormAccountEmail;
